import { CustomFilterOperator, ReportPropertyType } from "generated/openApi";

export const CustomFilterOperatorValueTypeEnum = ["Single", "Multiple", "None"] as const;

export type CustomFilterOperatorValueType = (typeof CustomFilterOperatorValueTypeEnum)[number];

export type CustomFilterOperatorOption = {
  operator: CustomFilterOperator;
  description?: string;
  filterValueType: CustomFilterOperatorValueType;
  canUseSelectList: boolean;
};

export const customFilterOperatorOptions: CustomFilterOperatorOption[] = [
  {
    operator: CustomFilterOperator.Equal,
    description: "equal",
    filterValueType: "Multiple",
    canUseSelectList: true,
  },
  {
    operator: CustomFilterOperator.NotEqual,
    description: "not equal",
    filterValueType: "Multiple",
    canUseSelectList: true,
  },
  {
    operator: CustomFilterOperator.GreaterThan,
    description: "greater than",
    filterValueType: "Single",
    canUseSelectList: false,
  },
  {
    operator: CustomFilterOperator.GreaterEqualThan,
    description: "greater than or equal",
    filterValueType: "Single",
    canUseSelectList: false,
  },
  {
    operator: CustomFilterOperator.LessThan,
    description: "less than",
    filterValueType: "Single",
    canUseSelectList: false,
  },
  {
    operator: CustomFilterOperator.LessEqualThan,
    description: "smaller than or equals",
    filterValueType: "Single",
    canUseSelectList: false,
  },
  {
    operator: CustomFilterOperator.Contains,
    description: "contains",
    filterValueType: "Multiple",
    canUseSelectList: false,
  },
  {
    operator: CustomFilterOperator.BeginsWith,
    description: "begins with",
    filterValueType: "Multiple",
    canUseSelectList: false,
  },
  {
    operator: CustomFilterOperator.EndsWith,
    description: "ends with",
    filterValueType: "Multiple",
    canUseSelectList: false,
  },
  {
    operator: CustomFilterOperator.IsNull,
    description: "is NULL",
    filterValueType: "None",
    canUseSelectList: false,
  },
  {
    operator: CustomFilterOperator.IsNotNull,
    description: "is not NULL",
    filterValueType: "None",
    canUseSelectList: false,
  },
];
